import { render, staticRenderFns } from "./documentdialog.vue?vue&type=template&id=0e661f40&"
import script from "./../ts/documentdialog.ts?vue&type=script&lang=js&"
export * from "./../ts/documentdialog.ts?vue&type=script&lang=js&"
import style0 from "./../assets/css/documentdialog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports